import api from '../config/api';
import { isApiEnabled } from '../config/appConfig';
import { getApiData, parseApiError } from './apiUtils';
import { isPasswordValid } from './passwordRecoveryService';

export const changeUserPassword = (usuarioId, { passwordActual, password, confirmPassword }) => {
  if (!usuarioId) {
    return Promise.reject(new Error('Debes iniciar sesión para cambiar tu contraseña.'));
  }

  if (!passwordActual) {
    return Promise.reject(new Error('La contraseña actual es obligatoria.'));
  }

  if (!password) {
    return Promise.reject(new Error('La nueva contraseña es obligatoria.'));
  }

  if (password !== confirmPassword) {
    return Promise.reject(new Error('Las contraseñas no coinciden.'));
  }

  if (!isPasswordValid(password)) {
    return Promise.reject(new Error('La contraseña no cumple con los requisitos.'));
  }

  if (!isApiEnabled()) {
    return Promise.reject(new Error('Cambiar contraseña requiere conexión con el servidor.'));
  }

  return api
    .post('/perfil_cambiar_password.php', {
      usuario_id: usuarioId,
      password_actual: passwordActual,
      password,
      confirm_password: confirmPassword,
    })
    .then((response) => getApiData(response, 'No se pudo actualizar la contraseña.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};
